import React from 'react';
import { Typography, Divider } from '@mui/material';

/**
 * Ein Impressum-Abschnitt: optionaler Trenner, Überschrift und beliebiger Inhalt.
 */
const ImpressumAbschnitt = ({ title, withDivider = false, children }) => (
    <>
        {withDivider && <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.1)' }} />}
        <Typography variant="h6" gutterBottom sx={{ color: '#e0f2fe', fontWeight: 600 }}>
            {title}
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: 'text.secondary' }}>
            {children}
        </Typography>
    </>
);

export default ImpressumAbschnitt;
